import { render } from "./ShowTicket.vue?vue&type=template&id=06695f9e"
import script from "./ShowTicket.vue?vue&type=script&lang=js"
export * from "./ShowTicket.vue?vue&type=script&lang=js"

import "./ShowTicket.vue?vue&type=style&index=0&id=06695f9e&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__